import React from 'react';
import { Link } from 'react-router-dom';
import FlavorService from '../../../services/flavor.service';
export default class Instancenav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flavour: this.props.instance.flavor,
            region: this.props.instance.region,
            isOptions: true,
            showVolumes: true,
            roleId: localStorage.getItem("roleId")
        };
    }

    componentDidMount() {
        let isOptions = this.getConsole(this.state.flavour.id);


        this.setState({
            isOptions: isOptions,
            showVolumes: this.getVolumesFlag(this.state.region)
        });
    }


    getVolumesFlag = region => {
        let hideVolumesArray = ['SFO1', 'PX1', 'ORD1', 'MIA1'];

        return !hideVolumesArray.includes(region);
    };

    getConsole = (flavorId) => {
        try {
            let flavorList = this.state.flavorList;
            let BmList = JSON.parse(localStorage.getItem('BMflavors'));
            if(flavorList === undefined) {
                flavorList = JSON.parse(localStorage.getItem('flavorList'));
            }
            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.flavour_id === flavorId);
                }
                catch(err) {
                    return '';
                }

                if(flavorObj === undefined) {
                    return '';
                }
                let nameArr = flavorObj.name.split(' ');

                if(nameArr[0].includes('SCPU')) {
                    return true;
                }
                if(nameArr[0].includes('DCPU')) {
                    return true;
                }
                if(nameArr[0].includes('BM')) {
                    return false;

                }
                //localStorage.setItem(flavorId, type + ', ' + processor + 'vCPU, ' + ram + ' RAM, ' + storage + ' NVMe storage')
                return true;
            }
        } catch(e) {

        }
        return '';
    };


    render() {
        let geturl = window.location.href;
        let instanceStatus = this.props.instance.status.toLowerCase();
        let isSrcMigCase = false;
        let isdestMigCase = false;
        if(this.props.instance.isSrcInst) isSrcMigCase = true;
        if(this.props.instance.metadata?.opType === 'migration') isdestMigCase = true;
        return (
            <aside className="instanceSetting_nav" value={ this.props.navParams } data-tip='' data-for="blockNav">
                {/* <ReactTooltip id="blockNav" place="right" effect = "solid" >{this.props.isTaskStateNull?'':'Snapshot is in progress'}</ReactTooltip> */ }
                <div className="settingModule_bg_shadow"></div>
                {/* <div className={this.props.isTaskStateNull?"block_nav":"block_nav show"} > </div> */ }
                <ul className='instanceNav'>
                    <li className={ geturl.indexOf("summary") !== -1 ? "set_summary active" : "set_summary" } style={ { display: this.state.isOptions ? "" : "none" } }>
                        <Link to="/server/summary">
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                <path fill="#868686" d="M7.3,16.8h8v-1h-8V16.8z M7.3,12.8h8v-1h-8V12.8z M18.3,7.8L18.3,7.8l-5-5.1h-8c-0.6,0-1,0.4-1,1v15  c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V7.8 M13.3,4.2l3.6,3.6h-3.6V4.2z M17.3,18.8h-12v-15h7v5h5V18.8z M7.3,14.8h8v-1h-8V14.8z" />
                            </svg> </span>Overview
                        </Link>
                    </li>

                    <li className={ geturl.indexOf("networking") !== -1 ? "set_netwk active" : "set_netwk " } style={ { display: instanceStatus !== "error" ? "flex" : "none" } }>
                        <Link to="/server/networking">
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                <path fill="#868686" d="M18.8,12.8h-2v-2h-5v-1h2c0.6,0,1-0.4,1-1v-5c0-0.6-0.4-1-1-1h-5c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h2v1h-5  v2h-2c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1v-5c0-0.6-0.4-1-1-1h-2v-1h9v1h-2c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5  c0.6,0,1-0.4,1-1v-5C19.8,13.3,19.4,12.8,18.8,12.8z M8.8,8.8v-5h5v5H8.8z M8.8,13.8v5h-5v-5H8.8z M18.8,18.8h-5v-5h5V18.8z" />
                            </svg> </span>Networking
                        </Link>
                    </li>


                    <li className={ geturl.indexOf("backups") !== -1 ? "set_bckup active" : "set_bckup" } style={ { display: this.state.isOptions ? "" : "none" } }>
                        <Link to="/server/backups">
                            <span className="svg_wrap">
                                <svg x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" style={ { enableBackground: "new 0 0 20 20" } } xmlSpace="preserve">
                                    <path fill="#868686" d="M14,8.5c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S17,8.5,14,8.5z M14,18.5c-2.5,0-4.5-2-4.5-4.5
                                        s2-4.5,4.5-4.5s4.5,2,4.5,4.5S16.5,18.5,14,18.5z M13.7,11.5l-2.2,2.2l0.7,0.7l1.3-1.3v3.3h1v-3.3l1.3,1.3l0.7-0.7l-2.2-2.2H13.7z
                                        M1.5,14.5V11c1.2,0.9,3.5,1.5,6.2,1.5c0.1-0.3,0.2-0.7,0.3-1c-3.6,0-6.5-1.2-6.5-2V5.7C2.8,6.8,5.2,7.5,8,7.5s5.2-0.7,6.5-1.8v1.8
                                        c0.3,0,0.7,0.1,1,0.2V4.5c0,0,0-0.3,0-0.5c0-1.9-3.4-3.5-7.5-3.5S0.5,2.1,0.5,4c0,0.2,0,0.5,0,0.5v10.1h0c0.1,1.6,3.4,2.9,7.5,2.9
                                        c0.2,0,0.3,0,0.5,0c-0.2-0.3-0.4-0.6-0.5-1C4.4,16.5,1.5,15.3,1.5,14.5z M8,1.5c3.6,0,6.5,1.1,6.5,2.5c0,1.4-2.9,2.5-6.5,2.5
                                        S1.5,5.4,1.5,4C1.5,2.6,4.4,1.5,8,1.5z"></path>
                                </svg>
                            </span>Backups
                        </Link>
                    </li>


                    <li className={ geturl.indexOf("snapshots") !== -1 ? "set_snapshot active" : "set_snapshot " } style={ { display: this.state.isOptions ? "" : "none" } }>
                        <Link to="/server/snapshots">
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                <path fill="#868686" d="M11.3,8.3c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S13.3,8.3,11.3,8.3z M11.3,14.3  c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S12.7,14.3,11.3,14.3z M16.8,6.3h-1.3l-0.7-2h-7l-0.7,2H5.8  c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h11c1.1,0,2-0.9,2-2v-8C18.8,7.2,17.9,6.3,16.8,6.3z M17.8,16.3c0,0.6-0.4,1-1,1h-11  c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1h2l0.6-2h5.7l0.7,2h2c0.6,0,1,0.4,1,1V16.3z" />
                            </svg>
                            </span>Snapshots
                        </Link>
                    </li>

                    <li className={ geturl.indexOf("voume") !== -1 ? "set_volume active" : "set_volume " } style={ { display: this.state.isOptions && this.state.showVolumes ? "" : "none" } }>

                        <Link to="/server/voume-instance">
                            <span className="svg_wrap"> <svg viewBox="0 0 16.41 14.51"><defs><style>{ "\
                            .cls-1{\
                                fill:#757577;fill-rule:evenodd;\
                            }\
                            "}</style></defs><path className="cls-1" d="M3.63,15.07H3.57a.5.5,0,0,1-.43-.56L4.09,7C4.33,6,4.84,4.59,6.58,4.59h9c1.43,0,2.11.64,2.48,2.39l1.43,7.38a.5.5,0,0,1-.4.58.49.49,0,0,1-.58-.4L17.12,7.18c-.33-1.52-.77-1.59-1.51-1.59h-9c-.68,0-1.2.27-1.51,1.61l-.94,7.43A.51.51,0,0,1,3.63,15.07Z" transform="translate(-3.13 -4.59)"></path><path className="cls-1" d="M18.05,19.09H4.63a1.5,1.5,0,0,1-1.5-1.5v-3a1.5,1.5,0,0,1,1.5-1.5H18.05a1.5,1.5,0,0,1,1.5,1.5v3A1.5,1.5,0,0,1,18.05,19.09Zm-13.42-5a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5H18.05a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5Z" transform="translate(-3.13 -4.59)"></path><path className="cls-1" d="M11.13,16.63H5.94a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h5.19a.5.5,0,0,1,.5.5A.5.5,0,0,1,11.13,16.63Z" transform="translate(-3.13 -4.59)"></path><path className="cls-1" d="M16.51,16.63H15.32a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.19a.5.5,0,0,1,.5.5A.5.5,0,0,1,16.51,16.63Z" transform="translate(-3.13 -4.59)"></path></svg>
                            </span>Volumes
                        </Link>
                    </li>


                    <li className={ geturl.indexOf("resize") !== -1 ? "set_resize active" : "set_resize" } style={ { display: this.state.isOptions && !isSrcMigCase && !isdestMigCase ? "" : "none" } }>
                        <Link to="/server/resize">
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                <path fill="#868686" d="M9.1,12.8l-4.3,4.3v-4.3h-1v5c0,0.6,0.4,1,1,1h5v-1H5.6l4.3-4.3L9.1,12.8z M9.8,4.8v-1h-5c-0.6,0-1,0.4-1,1  v5h1V5.6l4.3,4.3l0.8-0.8L5.6,4.8H9.8z M17.8,17.1l-4.3-4.3l-0.8,0.8l4.3,4.3h-4.3v1h5c0.6,0,1-0.4,1-1v-5h-1V17.1z M17.8,3.8h-5v1  h4.3l-4.3,4.3l0.8,0.8l4.3-4.2v4.2h1v-5C18.8,4.3,18.4,3.8,17.8,3.8z" />
                            </svg> </span>Resize
                        </Link>
                    </li>


                    <li className={ geturl.indexOf("rescue") !== -1 ? "set_rescue active" : "set_rescue " } style={ { display: this.state.isOptions && !isdestMigCase ? "" : "none" } }>
                        <Link to="/server/rescue">
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                <path fill="#868686" d="M11.3,3.3c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.8,3.3,11.3,3.3z M13.3,4.6c2.2,0.7,4,2.5,4.7,4.7h-2.1  c-0.5-1.2-1.4-2.1-2.6-2.6V4.6z M15.3,11.3c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S15.3,9.1,15.3,11.3z M10.3,4.4  c0.7-0.1,1.3-0.1,2,0v2c-0.7-0.1-1.3-0.1-2,0V4.4z M9.3,4.6v2.1C8.2,7.3,7.3,8.2,6.8,9.3H4.7C5.3,7.1,7.1,5.3,9.3,4.6z M4.4,10.3h2  c-0.2,0.7-0.2,1.3,0,2h-2c-0.1-0.3-0.1-0.7-0.1-1C4.3,11,4.4,10.7,4.4,10.3z M9.3,18c-2.3-0.7-4-2.5-4.7-4.7h2.1  c0.5,1.2,1.4,2.1,2.6,2.6V18z M12.3,18.2c-0.7,0.1-1.3,0.1-2,0v-2c0.7,0.1,1.3,0.1,2,0V18.2z M13.3,18v-2.1c1.2-0.5,2.1-1.4,2.6-2.6  H18C17.3,15.6,15.6,17.3,13.3,18z M16.2,12.3c0.2-0.7,0.2-1.3,0-2h2c0.1,0.3,0.1,0.7,0.1,1c0,0.3,0,0.7-0.1,1H16.2z" />
                            </svg> </span>Rescue
                        </Link>
                    </li>


                    <li className={ geturl.indexOf("rebuild") !== -1 ? "set_rebuild active" : "set_rebuild " }>
                        <Link to="/server/rebuild">
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                <path fill="#868686" d="M4.7,9.3c1.1-3.7,5-5.8,8.7-4.7c1.5,0.5,2.8,1.4,3.7,2.7h1.2C16,3.5,11.1,2.2,7.3,4.4  C5.5,5.5,4.1,7.3,3.6,9.3H1.3l3,4l3-4H4.7z M18.4,9.3l-3,4H18c-1.1,3.7-5,5.8-8.7,4.7c-1.5-0.5-2.8-1.4-3.7-2.7H4.4  c2.2,3.8,7.1,5.1,10.9,2.9c1.8-1.1,3.2-2.8,3.7-4.9h2.3L18.4,9.3z" />
                            </svg> </span>Rebuild
                        </Link>
                    </li>


                    <li className={ geturl.indexOf("activities") !== -1 ? "set_activity active" : "set_activity " } style={ { display: instanceStatus !== "error" ? "flex" : "none" } }>
                        <Link to="/server/activities">
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                <path fill="#868686" d="M12.3,3.3c-3.6,0-6.8,2.5-7.7,6H2.3l3,4l3-4H5.7c1.1-3.7,5-5.8,8.7-4.7s5.8,5,4.7,8.7s-5,5.8-8.7,4.7  c-1.5-0.5-2.8-1.4-3.7-2.7H5.4c2.2,3.8,7.1,5.1,10.9,2.9s5.1-7.1,2.9-10.9C17.8,4.9,15.2,3.3,12.3,3.3z M11.3,6.3v6h4v-1h-3v-5H11.3  z" />
                            </svg> </span>Activity
                        </Link>
                    </li>

                    <li className={ geturl.indexOf("instancebilling") !== -1 ? "bplan active" : "bplan " } style={ { display: this.state.isOptions && this.state.roleId === "2" && !isdestMigCase ? "flex" : "none" } }>
                        <Link to="/server/instancebilling">
                            <span className="svg_wrap">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15 15" enableBackground="new 0 0 15 15" xmlSpace="preserve">
                                    <text transform="matrix(1.0783 0 0 1 4.1372 11.4751)" className="bplan0 bplan1 bplan2">$</text>
                                    <path className="bplan3" d="M12.5,14.5h-10c-1.1,0-2-0.8-2-1.9V2.4c0-1,0.9-1.9,2-1.9h10c1.1,0,2,0.8,2,1.9v10.3
                                                    C14.5,13.7,13.6,14.5,12.5,14.5z"></path>
                                </svg>
                            </span>Billing
                        </Link>
                    </li>



                    <li className={ geturl.indexOf("setting") !== -1 ? "set_setting active" : "set_setting " } style={ { display: instanceStatus !== "error" ? "flex" : "none" } }>
                        <Link to="/server/settings">
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                <path fill="#868686" d="M11.3,7.8c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S13.3,7.8,11.3,7.8z M11.3,13.8  c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S12.7,13.8,11.3,13.8z M18.2,12.4l-0.4-0.3c0.1-0.6,0.1-1.1,0-1.7l0.4-0.3  c1-0.6,1.3-1.8,0.7-2.7l-0.5-0.9c-0.6-1-1.8-1.3-2.7-0.7l-0.4,0.3c-0.4-0.3-0.9-0.6-1.4-0.8V4.8c0-1.1-0.9-2-2-2h-1  c-1.1,0-2,0.9-2,2v0.5c-0.5,0.2-1,0.5-1.4,0.8L7,5.9C6,5.4,4.8,5.7,4.3,6.6L3.8,7.5c-0.6,1-0.2,2.2,0.7,2.7l0.4,0.3  c-0.1,0.6-0.1,1.1,0,1.7l-0.4,0.3c-1,0.6-1.3,1.8-0.7,2.7L4.3,16C4.8,17,6,17.3,7,16.8c0,0,0,0,0,0l0,0l0.4-0.3  c0.4,0.3,0.9,0.6,1.4,0.8v0.5c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-0.5c0.5-0.2,1-0.5,1.4-0.8l0.4,0.3c0.9,0.5,2.1,0.2,2.7-0.8  l0.5-0.9C19.5,14.2,19.1,13,18.2,12.4L18.2,12.4z M18.1,14.7l-0.5,0.9c-0.3,0.5-0.9,0.6-1.4,0.4l0,0l-1.1-0.6  c-0.7,0.6-1.5,1.1-2.3,1.3v1.2c0,0.6-0.4,1-1,1h-1c-0.6,0-1-0.4-1-1v-1.2c-0.9-0.2-1.7-0.7-2.3-1.4l-1.1,0.6C6,16.2,5.4,16,5.1,15.5  c0,0,0,0,0,0l0,0l-0.5-0.9c-0.3-0.5-0.1-1.1,0.4-1.4c0,0,0,0,0,0l0,0l1-0.6c-0.2-0.9-0.2-1.8,0-2.7L5,9.4C4.5,9.2,4.3,8.6,4.5,8.1  c0,0,0,0,0-0.1l0,0l0.5-0.9c0.3-0.5,0.9-0.6,1.4-0.4l0,0l1,0.6C8.1,6.7,8.9,6.3,9.8,6V4.8c0-0.6,0.4-1,1-1h1c0.6,0,1,0.4,1,1V6  c0.9,0.3,1.7,0.7,2.3,1.3l1-0.6c0.5-0.3,1.1-0.1,1.4,0.4c0,0,0,0,0,0l0,0L18,8c0.3,0.5,0.1,1.1-0.4,1.4c0,0,0,0,0,0l0,0l-1,0.6  c0.2,0.9,0.2,1.8,0,2.7l1.1,0.6C18.2,13.5,18.3,14.1,18.1,14.7C18.1,14.6,18.1,14.6,18.1,14.7L18.1,14.7L18.1,14.7z" />
                            </svg> </span>Settings
                        </Link>
                    </li>

                </ul>
            </aside >
        );
    }
}